import React from 'react';

const SRC = {
  mark: { color: '/brand/alvora-mark-color.png', white: '/brand/alvora-mark-white.png', black: '/brand/alvora-mark-black.png' },
  wordmark: { color: '/brand/alvora-wordmark-color.png', white: '/brand/alvora-wordmark-white.png', black: '/brand/alvora-wordmark-black.png' },
  full: { color: '/brand/alvora-logo-color.png', black: '/brand/alvora-logo-black.png' },
};

// Official Alvora assets. tone: 'color' on ivory, 'white' on charcoal.
export const BrandMark = ({ tone = 'color', size = 36, className = '', ...rest }) => (
  <img
    src={SRC.mark[tone]}
    alt="Alvora"
    width={size}
    height={size}
    draggable={false}
    className={`select-none object-contain ${className}`}
    style={{ width: size, height: size }}
    {...rest}
  />
);

export const BrandWordmark = ({ tone = 'color', height = 40, className = '', ...rest }) => (
  <img
    src={SRC.wordmark[tone]}
    alt="Alvora"
    height={height}
    draggable={false}
    className={`select-none object-contain ${className}`}
    style={{ height, width: 'auto' }}
    {...rest}
  />
);

export const BrandFullLogo = ({ tone = 'color', height = 72, className = '', ...rest }) => (
  <img
    src={SRC.full[tone]}
    alt="Alvora — Crafting Exceptional Homes"
    height={height}
    draggable={false}
    className={`select-none object-contain ${className}`}
    style={{ height, width: 'auto' }}
    {...rest}
  />
);

// Compact navigation lockup: mark + "Alvora OS" (no tagline)
export const BrandLockup = ({ tone = 'white', markSize = 36, textClass = '', ...rest }) => (
  <span className="flex items-center gap-3" {...rest}>
    <BrandMark tone={tone} size={markSize} />
    <span className={`font-display font-semibold tracking-[0.08em] uppercase text-sm ${textClass}`}>Alvora OS</span>
  </span>
);
